var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSave = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 3C3.91848 3 3.60054 3.1317 3.36612 3.36612C3.1317 3.60054 3 3.91848 3 4.25V19.75C3 20.0815 3.1317 20.3995 3.36612 20.6339C3.60054 20.8683 3.91848 21 4.25 21H6V12.75C6 12.3358 6.33579 12 6.75 12H17.25C17.6642 12 18 12.3358 18 12.75V21H19.75C20.0815 21 20.3995 20.8683 20.6339 20.6339C20.8683 20.3995 21 20.0815 21 19.75V8.31066L15.6893 3H7.5V7.5H15.75C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 8.66421 16.1642 9 15.75 9H6.75C6.33579 9 6 8.66421 6 8.25V3H4.25ZM16.5 21H7.5V13.5H16.5V21ZM2.30546 2.30546C2.82118 1.78973 3.52065 1.5 4.25 1.5H16C16.1989 1.5 16.3897 1.57902 16.5303 1.71967L22.2803 7.46967C22.421 7.61032 22.5 7.80109 22.5 8V19.75C22.5 20.4793 22.2103 21.1788 21.6945 21.6945C21.1788 22.2103 20.4793 22.5 19.75 22.5H4.25C3.52066 22.5 2.82118 22.2103 2.30546 21.6945C1.78973 21.1788 1.5 20.4793 1.5 19.75V4.25C1.5 3.52065 1.78973 2.82118 2.30546 2.30546Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/save.ffd8cde5d3c4b558cf66c486af5a5820.svg";